import { DATA_BAG, DYNAMIC_DATA_BAGS } from 'defs/offlineAvailability';
import { VIEW_MAP_PAYLOAD_EXTRACTOR, VIEW_REQUIRES_DATA_BAG_MAP } from 'defs/offlineAvailability';
import { template } from 'helper/string';
import { OfflineAvailabilityStateType } from 'store/offlineAvailability';

const dynamicDataBagIds: string[] = [];

/*
 * Create the initial state for each databag inside redux store
 * @param {Object} initialState
 */
export const createDataBagState = (
	initialState: Partial<OfflineAvailabilityStateType> = {}
): OfflineAvailabilityStateType => {
	Object.keys(DATA_BAG).forEach((dataBagId: string) => {
		const dataBagInternalId = DATA_BAG[dataBagId];

		if (!!~DYNAMIC_DATA_BAGS.indexOf(dataBagInternalId) === false) {
			initialState[dataBagInternalId] = false;
		}
	});

	return initialState as OfflineAvailabilityStateType;
};

/*
 * Generate a DataBag key for static and dynamic DataBags
 * @param {string} dataBagId
 * @param {Object?} additionalPayload
 */
export const generateDataBagKeyType = (dataBagId: string, additionalPayload?: Object): string => {
	let dataBagFinalId: string = dataBagId;

	if (additionalPayload && !!~DYNAMIC_DATA_BAGS.indexOf(dataBagId)) {
		dataBagFinalId = template(dataBagId, additionalPayload);
		dynamicDataBagIds.push(dataBagFinalId);
	}

	return dataBagFinalId;
};

/*
 * Filter the payload of a certain databag for compilation
 * @param {string} dataBagId
 * @param {Object?} additionalPayload
 */
export const getFilteredPayload = (dataBagId: string, additionalPayload?: Object): Object | null => {
	if (!additionalPayload) {
		return null;
	}

	if (!VIEW_MAP_PAYLOAD_EXTRACTOR[dataBagId]) {
		return null;
	}

	const fieldsToExtract = VIEW_MAP_PAYLOAD_EXTRACTOR[dataBagId];
	const filteredPayload = {};

	Object.keys(additionalPayload).forEach((key: string): void => {
		if (!!~fieldsToExtract.indexOf(key)) {
			filteredPayload[key] = (additionalPayload || {})[key];
		}
	});

	return Object.keys(filteredPayload).length > 0 ? filteredPayload : null;
};

/*
 * Get a list of required DataBag keys with an additional payload,
 * used for ALL DataBags atm.
 * @param {string} viewId
 * @param {Object?} additionalPayload
 * @returns {Array<string>}
 */
export const getRequiredDataBagsForViewId = (viewId: string, additionalPayload?: Object): string[] => {
	return (VIEW_REQUIRES_DATA_BAG_MAP[viewId] || []).map((requiredDataBagKeyType: string) => {
		return generateDataBagKeyType(requiredDataBagKeyType, additionalPayload);
	});
};

export const getDynamicDataBagKeyTypes = () => dynamicDataBagIds;

export default {
	createDataBagState,
	generateDataBagKeyType,
	getDynamicDataBagKeyTypes,
};
